<span ngbDropdown>
    <span ngbDropdownToggle>
        <img src="https://agcdn.altametrics.com/hw-img/DEV/other/filter.svg" class="filter-icon" id="gridHeaderdropdown" />
    </span>
<span ngbDropdownMenu aria-labelledby="gridHeaderdropdown">
        <div class="filter-list ">
            <div class="filter-option-list">
                <ul class="filter-option-value">
                    <li [ngClass]="{'active':this.isTextActive}" (click)="this.isTextActive = true;">Text</li>
                    <li [ngClass]="{'active':!this.isTextActive}" (click)="this.isTextActive = false;">Pin</li>
                </ul>
            </div>
            <div class="filter-option-wrapper" [ngClass]="{'active':this.isTextActive}">
                <fn-grid-column-search-filter [column]="column" (callback)="callback.emit($event)"></fn-grid-column-search-filter>
            </div>
            <div class="filter-option-wrapper" [ngClass]="{'active':!this.isTextActive}">
                <fn-grid-column-pin-filter [pinTo]="column.pinTo" [field]="column.field" (callback)="callback.emit($event)"></fn-grid-column-pin-filter>
            </div>
        </div>
    </span>
</span>
